import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BedbankDetailsSection from './BedbankDetailsSection'

import FoldableContent from 'components/Common/FoldableContent/FoldableContent'
import { BaseImage } from 'components/Common/OrderView/styles'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

interface Prop {
  offer: App.BedbankOffer
  pkg: App.BedbankPackage
}

function PlannedBedbankOfferPackageSummary({ offer, pkg }: Prop) {
  const imageId = pkg.images[0]?.id || offer.image.id
  return (
    <BookingDetails>
      <Heading variant="heading5">Your Package</Heading>
      {imageId && (
        <BaseImage
          className="hidden-print"
          id={imageId}
          mobileAspectRatio="9:4"
          mobileWidth="100"
        />
      )}
      <BodyText variant="medium" weight="bold">
        {pkg.name}
      </BodyText>
      <FoldableContent
        openLabel="Hide package and room details"
        closedLabel="View package and room details"
      >
        <BedbankDetailsSection pkg={pkg} />
      </FoldableContent>
    </BookingDetails>
  )
}

export default PlannedBedbankOfferPackageSummary
